import React, { FC } from 'react';

export const TextArea = ({ textAreaObject, label, placeholder, componentId }) => {
	return (
		<label data-selection={componentId} className="vtex-textarea">
			<span className="vtex-textarea__label db mb3 w-100 t-body ">{label || 'Textarea'}</span>
			<textarea
				className="vtex-textarea__input w-100 ma0 border-box pv3 ph5 bw1 br2 b--solid outline-0 c-on-base t-small b--muted-4 hover-b--muted-3 bg-base t-body "
				style={{
					resize: 'both',
					'-webkit-appearance': 'none',
				}}
			></textarea>
			<div className="flex justify-between">
				<div></div>
			</div>
		</label>
	);
};
